import { createFileRoute } from '@tanstack/react-router';
import { OperationsWorkbenchPage } from '@/features/workbench/page';

export const Route = createFileRoute('/_authenticated/')({
  component: OperationsWorkbenchPage,
});
